import { LEGAL_DOCUMENT_BODY_CLASS } from "./legalDocumentBodyClass";
import { LegalDocumentRevisionFooter } from "./LegalDocumentRevisionFooter";

export function SubscriptionContent() {
  return (
    <div className={LEGAL_DOCUMENT_BODY_CLASS}>
      <h1>Условия подписки</h1>

      <h2>1. Premium</h2>
      <p>
        Подписка Premium открывает расширенный доступ к функциям Mom Recipes:
        несколько профилей семьи, семейный режим, персонализация с учётом возраста и
        ограничений, расширенные возможности плана и чата, а также иные функции,
        помеченные в приложении как доступные в Premium или при активном trial.
      </p>

      <h2>2. Пробный период (trial)</h2>
      <p>
        При наличии соответствующей опции в интерфейсе Пользователь может
        активировать бесплатный пробный период с доступом к функциям Premium. В
        текущей версии приложения длительность trial составляет до 3 дней (если
        иное явно не указано на экране активации). Пробный период может быть
        предоставлен один раз на учётную запись — в соответствии с логикой
        приложения и настройками на стороне сервиса.
      </p>

      <h2>3. Оплата и срок доступа</h2>
      <p>
        Оплата подписки за месяц или за год производится через платёжного
        провайдера (эквайринг Т-Бизнес / Тинькофф) по ссылке из приложения.
        Пользователь оплачивает выбранный период; доступ к Premium предоставляется
        на срок, соответствующий оплаченному тарифу, согласно данным, отображаемым
        в приложении после успешной оплаты.
      </p>
      <p>
        В текущей реализации приложения <strong>автоматическое продление</strong>{" "}
        подписки путём повторного списания с карты <strong>не подключается</strong>.
        Для продления доступа после окончания оплаченного периода может
        потребоваться новое оформление оплаты в приложении. Если способ оплаты или
        условия будут изменены, актуальная информация будет отражена в этом
        документе и/или в интерфейсе оплаты.
      </p>

      <h2>4. Отмена</h2>
      <p>
        Пользователь может отменить подписку (пометить отказ от дальнейшего
        продления в рамках доступных в приложении действий) в разделе управления
        подпиской в личном кабинете. Оплаченный период доступа, уже
        предоставленный на момент отмены, как правило, сохраняется до даты
        окончания, указанной в приложении, если иное не вытекает из технической
        реализации или правил платёжного провайдера.
      </p>

      <h2>5. Возврат средств</h2>
      <p>
        Пользователь вправе обратиться к Исполнителю по вопросу возврата денежных
        средств в течение 24 часов после совершения первой оплаты подписки.
      </p>
      <p>
        Каждое обращение рассматривается <strong>в индивидуальном порядке</strong>.
        При рассмотрении могут учитываться, в частности: обстоятельства и
        корректность проведения оплаты; возможные технические ошибки на стороне
        платёжного оператора или сервиса; фактический объём использования сервиса и
        предоставленный доступ к платным функциям Premium за соответствующий
        период; позиция платёжного посредника и применимые к сделке правила.
      </p>
      <p>
        Исполнитель рассматривает обращения добросовестно, однако{" "}
        <strong>автоматический возврат</strong> по одному лишь факту запроса{" "}
        <strong>не гарантируется</strong> и не предусмотрен, за исключением случаев,
        когда возврат прямо предписан законом. Решение по конкретному обращению
        зависит от совокупности обстоятельств; отказ в возврате в том числе возможен,
        если доступ к платным функциям был предоставлен и сервис использовался в
        существенном объёме, если иное не следует из императивных норм права.
      </p>

      <h2>6. Контакты</h2>
      <p>
        Email для поддержки:{" "}
        <a href="mailto:aiapps.probusiness@gmail.com">aiapps.probusiness@gmail.com</a>
      </p>
      <LegalDocumentRevisionFooter />
    </div>
  );
}
